@if (!isMinimized()) {
  <div
    class="card board mx-2 sprint-column-card-root"
    [ngClass]="tcTicketService.getBackgroundColor(color)">
    <div
      class="py-3 card-header text-center cursor-pointer"
      [ngClass]="tcTicketService.getAlertColor(color)"
      (click)="titleClicked.emit({ title: formattedTitle, color })"
      pDroppable
      (onDrop)="
        dropEmitter.emit({
          event: $event,
          target: 'sprintHeader',
          title: title,
        })
      ">
      @if (!useSprintObjLength) {
        <p class="m-0">
          {{ formattedTitle }}
          @if (totalPoints > 0 && totalCompletedPoints === totalPoints) {
            <patron-icon
              name="pi-check-circle"
              class="text-success ml-1"
              pTooltip="Tarefas concluídas"></patron-icon>
          }
          ({{ totalCompletedPoints }}/{{ totalPoints }})
          @if (hasUrgent) {
            <patron-icon
              name="bi-exclamation-triangle-fill"
              class="text-danger ml-1"
              pTooltip="Urgente"></patron-icon>
          }
          @if (hasFailedTests) {
            <patron-icon
              name="bi-x-octagon-fill"
              class="text-danger ml-1"
              pTooltip="Teste não ok"></patron-icon>
          }
          @if (hasBug) {
            <patron-icon
              name="bi-bug-fill"
              class="text-danger ml-1"
              pTooltip="Defeito / Retrabalho"></patron-icon>
          }
          @if (hasPendingRelease) {
            <patron-icon
              name="pi-lock"
              class="text-primary ml-1"
              pTooltip="Liberação pendente"></patron-icon>
          }
        </p>
      } @else {
        <p class="m-0">{{ formattedTitle }} ({{ totalSprintObjLength }})</p>
      }
      <ng-template #sprintObjTemplate1>
        <p class="m-0">{{ formattedTitle }} ({{ totalSprintObjLength }})</p>
      </ng-template>
    </div>
    <div class="card-content">
      <patron-accordion
        [customTabs]="tabs"
        [activeIndex]="activeIndex"
        [multiple]="false"
        (onOpen)="tabOpened($event)"
        (onClose)="tabClosed($event)"
        [customClass]="'sprint-accordion ' + tcTicketService.getAccordionColorClass(color)">
        @for (user of userNames; track trackByUser($index, user)) {
          @let bucket = sprintObj?.[user];
          <ng-template #userHeader>
            <div
              class="row justify-content-between w-100"
              pDroppable
              (onDrop)="
                dropEmitter.emit({
                  event: $event,
                  target: 'userHeader',
                  title: title,
                  user: user,
                })
              ">
              <div class="col-auto">
                {{ user }}
                @if (bucket?.hasUrgent) {
                  <patron-icon
                    name="bi-exclamation-triangle-fill"
                    class="text-danger mr-2"
                    pTooltip="Urgente"></patron-icon>
                }
                @if (bucket?.hasFailedTests) {
                  <patron-icon
                    name="bi-x-octagon-fill"
                    class="text-danger mr-2"
                    pTooltip="Teste não ok"></patron-icon>
                }
                @if (bucket?.hasBug) {
                  <patron-icon
                    name="bi-bug-fill"
                    class="text-danger mr-2"
                    pTooltip="Defeito / Retrabalho"></patron-icon>
                }
                @if (bucket?.hasPendingRelease) {
                  <patron-icon
                    name="pi-lock"
                    class="text-primary mr-2"
                    pTooltip="Liberação pendente"></patron-icon>
                }
              </div>
              @if (bucket) {
                <div class="col-auto pr-0">
                  @if (
                    bucket['estimatedEffort'] &&
                    bucket['finishedPoints'] === bucket['estimatedEffort']
                  ) {
                    <span>
                      <patron-icon
                        name="pi-check-circle"
                        class="text-success"
                        pTooltip="Tarefas concluídas"></patron-icon>
                    </span>
                  }
                  @if (!useSprintObjLength) {
                    <span>
                      {{ bucket['finishedPoints'] }}/{{ bucket['estimatedEffort'] }}
                      ponto(s)
                    </span>
                  } @else {
                    <span> {{ bucket['ticketTasks']?.length }} chamado(s) </span>
                  }
                  <ng-template #sprintObjTemplate2>
                    <span> {{ bucket['ticketTasks']?.length }} chamado(s) </span>
                  </ng-template>
                </div>
              }
            </div>
          </ng-template>
          <ng-template #userContent>
            @if (bucket) {
              <div>
                @for (
                  ticketTask of ticketTasksMap[user];
                  track trackByTask(ticketTaskIndex, ticketTask);
                  let ticketTaskIndex = $index
                ) {
                  <div
                    pDroppable
                    (onDrop)="
                      dropEmitter.emit({
                        event: $event,
                        target: 'ticketCard',
                        ticketTask: ticketTask,
                        title: title,
                        user: user,
                        index: ticketTask.badge ? 0 : ticketTaskIndex,
                        parentIndex: ticketTask.badge ? ticketTaskIndex : undefined,
                      })
                    ">
                    @if (ticketTask.badge) {
                      <app-sprint-inner-column
                        [ticketTask]="ticketTask"
                        [title]="title"
                        [user]="user"
                        [color]="color"
                        [readOnly]="readOnly"
                        [parentIndex]="ticketTaskIndex"
                        [isBeta]="isBeta"
                        (dragStartEmitter)="dragStartEmitter.emit($event)"
                        (dropEmitter)="dropEmitter.emit($event)"
                        (openTicketModalEmitter)="
                          openTicketModalEmitter.emit($event)
                        "></app-sprint-inner-column>
                    }
                    @if (!ticketTask.badge) {
                      <app-ticket-card-container
                        pDraggable
                        (onDragStart)="
                          dragStartEmitter.emit({
                            event: $event,
                            ticketTask: ticketTask,
                            title: title,
                            user: user,
                            index: ticketTaskIndex,
                          })
                        "
                        (onDragEnd)="dragEndEmitter.emit($event)"
                        [ticketTask]="ticketTask"
                        [user]="user"
                        [title]="title!"
                        [color]="color"
                        [showDate]="false"
                        [readOnly]="readOnly"
                        (click)="openTicketModal($event, ticketTask)"
                        [isBeta]="isBeta"></app-ticket-card-container>
                    }
                  </div>
                }
              </div>
            }
          </ng-template>
        }
      </patron-accordion>
    </div>
  </div>
}
